













import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import PaginationComponent from '@/_shared/components/pagination/pagination.component.vue';
import chunk from 'lodash/chunk';

const ALL = 0;

@Component({
  components: {
    PaginationComponent,
  },
})
export default class FrontendPagination extends Vue {
  @Prop({
    type: Number,
    required: true,
  })
  public itemsPerPage!: number;

  @Prop({
    type: Number,
    required: true,
  })
  public currentPage!: number;

  @Prop({
    type: Array,
    default: () => [10, 20, 50, ALL],
  })
  public itemsPerPageOptions!: number[];

  @Prop({
    type: Array,
    required: true,
  })
  public allItems!: any[];

  @Prop({
    type: String,
    default: 'GENERIC.ITEMS',
  })
  public itemsPluralKey!: string;

  @Prop({
    type: String,
    default: 'GENERIC.ITEM',
  })
  public itemsSingularKey!: string;

  @Prop({
    type: Boolean,
    default: true,
  })
  public showPaginationSummary!: boolean;

  get itemsPerPageProxy() {
    return this.itemsPerPage;
  }
  set itemsPerPageProxy(itemsPerPage: number) {
    this.$emit('update:items-per-page', itemsPerPage);
  }

  get currentPageProxy() {
    return this.currentPage;
  }
  set currentPageProxy(currentPage: number) {
    this.$emit('update:current-page', currentPage);
  }

  get pages(): any {
    const itemsPerPage = this.itemsPerPage || this.allItems.length;
    return chunk(this.allItems, itemsPerPage);
  }

  get currentPageItems() {
    return this.pages[this.currentPage - 1] || [];
  }

  get showPagination(): boolean {
    return !!this.currentPageItems.length;
  }

  @Watch('currentPageItems', { immediate: true })
  onChangeCurrentPageItems() {
    this.$emit('update-current-page-items', this.currentPageItems);
  }
}
